import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  choosePaymentMethod: {
    id: 'payAtPump:thereAreSomePaymentMethodsAdded:choosePaymentMethodButtonTitle',
    defaultMessage: 'Choose payment method',
    description: 'Pay at pump - there are some payment methods added - Choose payment method button title',
  },
});
